import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'src/containers/App/App';
import * as serviceWorker from './serviceWorker';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { REACT_APP_CAPTCHA_KEY } from './utils/pnd/config';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <GoogleReCaptchaProvider reCaptchaKey={REACT_APP_CAPTCHA_KEY}>
    <App />
  </GoogleReCaptchaProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();